import _extends from 'babel-runtime/helpers/extends';
import _Object$assign from 'babel-runtime/core-js/object/assign';

import _ from 'lodash';
import TableList from '@/components/TableList/index.vue';
import { parseTime } from '@/filters/index';
import { langType, blogLangType, categoryType, casesType
// logoPosition,
// uploadType
} from '../config';

import { caseTag } from '../config';

export default {
  components: {
    TableList: TableList
  },

  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    columnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    tableConfig: {
      type: Object,
      default: function _default() {}
    },

    handleSortChange: {
      type: Function,
      default: function _default() {}
    },

    handleSelectionChange: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      tableColumnConfig: [{
        label: 'ID',
        prop: 'id'
      }, {
        label: '语言版本',
        prop: 'lang',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            // 根据是否有title区分作品和博客
            var language = row.title ? blogLangType : langType;
            var lang = language.find(function (item) {
              return item.value === Number(row.lang);
            });
            return lang ? lang.label : '-';
          }
        }
      }, {
        label: '作品名称',
        prop: 'name',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            var temp = '';
            if (row.lang === 1) {
              temp += '<div>\u4E2D\u6587\uFF1A' + row.name + '</div>';
            }
            if (row.lang === 2) {
              temp += '<div>\u82F1\u6587\uFF1A' + row.e_name + '</div>';
            }
            if (row.lang === 3) {
              temp += '<div>\u4E2D\u6587\uFF1A' + row.name + '</div><div>\u82F1\u6587\uFF1A' + row.e_name + '</div>';
            }
            return temp;
          }
        }
      }, {
        label: '标题',
        prop: 'title'
      }, {
        label: '作品类型',
        width: 150,
        prop: 'type',
        params: {
          innerText: function innerText(_ref3) {
            var row = _ref3.row;

            var lang = casesType.find(function (item) {
              return item.value === Number(row.type);
            });
            return lang ? lang.label : '-';
          }
        }
      }, {
        label: '作品标签',
        width: 150,
        prop: 'labels',
        params: {
          innerText: function innerText(_ref4) {
            var row = _ref4.row;

            var temp = [];
            if (row.labels) {
              var list = row.labels.split(',');
              list.forEach(function (value) {
                var currentItem = caseTag.find(function (item) {
                  return item.value === Number(value, 10);
                });
                if (currentItem) {
                  temp.push(currentItem.label);
                }
              });
            }
            return temp.length > 0 ? temp.join() : '-';
          }
        }
      }, {
        label: '博客类型',
        width: 150,
        prop: 'blogType',
        params: {
          innerText: function innerText(_ref5) {
            var row = _ref5.row;

            var lang = categoryType.find(function (item) {
              return item.value === Number(row.type);
            });
            return lang ? lang.label : '-';
          }
        }
      }, {
        label: '作品缩略图',
        width: 150,
        prop: 'thumb_url',
        type: 'image',
        params: {
          preview: true
        }
      }, {
        label: '发布时间',
        prop: 'publish_time',
        sortable: 'custom',
        params: {
          innerText: function innerText(_ref6) {
            var row = _ref6.row;

            return parseTime(row.publish_time, '{y}-{m}-{d} {h}:{i}:{s}');
          }
        }
      }, {
        label: '更新时间',
        prop: 'updated_time',
        sortable: 'custom',
        params: {
          innerText: function innerText(_ref7) {
            var row = _ref7.row;

            return parseTime(row.updated_time, '{y}-{m}-{d} {h}:{i}:{s}');
          }
        }
      }, {
        slot: 'setting-cell',
        prop: 'setting-cell'
      }, {
        slot: 'top-cell',
        prop: 'top-cell'
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }]
    };
  },


  computed: {
    innerTableConfig: function innerTableConfig() {
      return _Object$assign({}, _extends({}, this.tableConfig));
    },
    innerList: function innerList() {
      if (_.isArray(this.list)) {
        return this.list;
      }
      return [];
    },


    // 过滤表数据
    filterColumnConfig: function filterColumnConfig() {
      var _this = this;

      var tempConfig = [];
      this.columnConfig.map(function (columnProp) {
        _this.tableColumnConfig.map(function (item) {
          if (columnProp && item.prop === columnProp) {
            tempConfig.push(item);
          }
        });
      });

      return tempConfig;
    }
  },

  methods: {}
};